export interface StageConfig {
    name: string;
    estimatedMs: number;
    canExtend: boolean;
}

export interface ProgressState {
    steps: Array<{ name: string; estimatedMs: number }>;
    currentStepIndex: number;
    stepStartTime: number;
    processStartTime: number;
    initialTotalMs: number;
    fixedOverrunMs: number; // sum of overruns from completed steps
}

export function calculateTimeBasedProgress(progressState: ProgressState) {
    const now = Date.now();

    // Calculate current step elapsed time
    const currentStepElapsed = now - progressState.stepStartTime;
    const currentStepEstimate = progressState.steps[progressState.currentStepIndex]?.estimatedMs || 0;

    // Calculate live overrun for current step
    const liveOverrun = Math.max(0, currentStepElapsed - currentStepEstimate);

    // Calculate current total estimate
    const currentTotalMs = progressState.initialTotalMs + progressState.fixedOverrunMs + liveOverrun;

    const totalElapsed = currentStepElapsed + progressState.steps.slice(0, progressState.currentStepIndex).reduce(
        (sum, step) => sum + step.estimatedMs,
        0
    ) + progressState.fixedOverrunMs;

    // Calculate progress percentage
    const percentage = Math.min((totalElapsed / currentTotalMs) * 100, 99);

    return { percentage, currentTotalMs, totalElapsed };
}

export function completeStep(progressState: ProgressState, actualDurationMs: number): ProgressState {
    const currentStep = progressState.steps[progressState.currentStepIndex];
    if (!currentStep) {
        return progressState;
    }

    // Calculate overrun for this step
    const overrun = Math.max(0, actualDurationMs - currentStep.estimatedMs);

    return {
        ...progressState,
        currentStepIndex: progressState.currentStepIndex + 1,
        stepStartTime: Date.now(),
        fixedOverrunMs: progressState.fixedOverrunMs + overrun
    };
}
